// src/components/Navbar.js
import { NavLink } from 'react-router-dom';
import Logo from '../assets/images/sk-logo.png';

function Navbar() {
    // Función para decodificar el JWT
    const decodeJWT = (token) => {
        try {
            const base64Url = token.split('.')[1]; // Obtener el payload
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Reemplazar caracteres especiales
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload); // Convertir a objeto JavaScript
        } catch (error) {
            console.error('Error decodificando el JWT:', error);
            return null;
        }
    };

    // Obtener el authtoken desde el localStorage
    const authToken = localStorage.getItem('authToken');

    // Decodificar el JWT y extraer el menú
    const decodedToken = authToken ? decodeJWT(authToken) : null;
    let menu = decodedToken?.menu || []; 

    // Procesar el menú para aplicar los cambios solicitados por el usuario
    const processMenu = (items) => {
        return items
            .filter(item => {
                // Quitar "Crear" viejo y "Resolver" viejo
                if (item.path === '/solicitud-reemplazo' || item.path === '/ingreso-reemplazos') return false;
                return true;
            })
            .map(item => {
                let newItem = { ...item };
                
                // Renombrar V2 a nombres limpios
                if (newItem.path === '/new-solicitud-reemplazo') newItem.name = 'Crear';
                if (newItem.path === '/new-ingreso-reemplazos') newItem.name = 'Resolver';
                
                // Inyectar Config. Resumen en Administración
                if (newItem.name === 'Administración') {
                    if (!newItem.children) newItem.children = [];
                    // Evitar duplicados si vuelve a procesar
                    if (!newItem.children.find(c => c.path === '/configuracion-honorarios')) {
                        newItem.children.push({
                            id: 'config-resumen-manual',
                            name: 'Config. Resumen',
                            path: '/configuracion-honorarios',
                            children: []
                        });
                    }
                }

                if (newItem.name === 'Cobranza') {
                    if (!newItem.children) newItem.children = [];
                    if (!newItem.children.find(c => c.path === '/reajuste-valores-familia')) {
                        newItem.children.push({
                            id: 'reajuste-valores-familia-manual',
                            name: 'Reajuste Valores Familia',
                            path: '/reajuste-valores-familia',
                            children: []
                        });
                    }
                }

                // Procesar hijos si existen
                if (newItem.children && newItem.children.length > 0) {
                    newItem.children = processMenu(newItem.children);
                }
                
                return newItem;
            });
    };

    menu = processMenu(menu);

    const cerrarSesion = () => {
        localStorage.clear(); // Limpiar el localStorage
        window.location.href = '/'; // Redirigir al inicio
    };

    // Función para generar los elementos del menú
    const renderMenu = (menuItems) => {
        return menuItems.map((item) => {
            if (item.children && item.children.length > 0) {
                return (
                    <li className="nav-item dropdown" key={item.id}>
                        <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            id={`nav-${item.id}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {item.name}
                        </a>
                        <ul className="dropdown-menu" aria-labelledby={`nav-${item.id}`}>
                            {renderMenu(item.children)}
                        </ul>
                    </li>
                );
            } else {
                return (
                    <li key={item.id}>
                        <NavLink to={item.path} className="dropdown-item">
                            {item.name}
                        </NavLink>
                    </li>
                );
            }
        });
    };

    return (
        <nav className="navbar navbar-expand-sm shadow-sm bg-white" aria-label="Third navbar example">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img src={Logo} alt="SK Logo" className="nav-logo" />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse bg-white" id="navbarNav">
                    <ul className="navbar-nav me-auto mb-2 mb-sm-0">
                        {renderMenu(menu)}
                    </ul>
                    {/* Botones de Ayuda y Cerrar Sesión */}
                    <ul className="navbar-nav mb-2 mb-sm-0 align-items-center">
                        <li className="nav-item me-2">
                            <NavLink to="/ayuda" className="nav-link d-flex align-items-center">
                                <i className="bi bi-question-circle fs-5 me-1"></i>
                                Ayuda
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link d-flex align-items-center" onClick={cerrarSesion}>
                                <i className="bi bi-box-arrow-right fs-5 me-1"></i>
                                Cerrar Sesión
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
